"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionOccupancyStatus = void 0;
var SessionOccupancyStatus;
(function (SessionOccupancyStatus) {
    SessionOccupancyStatus["AVAILABLE"] = "AVAILABLE";
    SessionOccupancyStatus["WAITLIST_AVAILABLE"] = "WAITLIST_AVAILABLE";
    SessionOccupancyStatus["FULL"] = "FULL";
})(SessionOccupancyStatus = exports.SessionOccupancyStatus || (exports.SessionOccupancyStatus = {}));
//# sourceMappingURL=session.dto.js.map